import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import KBLearnMore from "../../../components/learnMore/KBLearnMore";
import { ILEARN_URLS } from "../../../constants/ilearnUrls";
import { useDispatch, useSelector } from "react-redux";
import { Charts } from "../views";
import { FETCH_CURRENT_USER } from "../common/saga";

const MODULE_HEIGHT = 550;

const FirstVisitConversions = (props) => {
  const dispatch = useDispatch();
  const { isLoading, initialRequest } = useSelector((state) => state.firstVisitConversions);
  const [filtersDirtySt2, setFiltersDirtySt2] = useState(false);

  useEffect(() => {
    fetchInitialData();
  }, []);

  function fetchInitialData(reset) {
    if (!initialRequest || reset) {
      dispatch({
        type: FETCH_CURRENT_USER + props.moduleName,
        payload: {
          chartType: props.moduleName,
          ...props
        }
      });

      setFiltersDirtySt2(false);
    }
  }

  return (
    <>
      <Charts
        sectionProps={{
          title: "First Visit Conversions",
          learnMore: (
            <KBLearnMore
              title="First Visit Conversions"
              description="This report shows prospects who converted after their first qualifying visit within the selected date range. These insights help you measure the effectiveness of early-stage experiences and track how well first visits translate into purchases."
              kbUrl={ILEARN_URLS.instructorPerformance.firstVisitConversions}
            />
          ),
          customClass: `instructorperformanceWidget ${isLoading ? "" : "active"}`,
          height: MODULE_HEIGHT,
          isLoading: isLoading
        }}
        currentUser={props}
        filtersDirtySt={filtersDirtySt2}
        fetchInitialData={fetchInitialData}
        isLoading={isLoading}
        moduleName={props.moduleName}
      />
    </>
  );
};

FirstVisitConversions.propTypes = {
  isLoading: PropTypes.bool,
  currentUser: PropTypes.object,
  moduleName: PropTypes.string
};

export default FirstVisitConversions;
